import { staticTable } from "@-/dev.improve.haniverse.database.schemas.static._lib.table";
import { wordTable } from "@-/dev.improve.haniverse.database.schemas.static.schema._tables.word";
import { index, integer, real } from "@-/dev.improve.haniverse.lib.database.table";

export const wordSubtlexTable = staticTable(
  "word_subtlex",
  {
    wordId: integer("word_id")
      .notNull()
      .references(() => wordTable.id),

    /** 1-based frequency rank (1 = most frequent). Derived from SUBTLEX-CH-WF WCount. */
    rank: integer("rank").notNull(),

    /** W/million */
    frequencyPerMillion: real("frequency_per_million").notNull(),

    /** W-CD% */
    contextCoverage: real("context_coverage").notNull(),

    /** logW-CD */
    diversityScore: real("diversity_score").notNull(),
  },
  (table) => [
    index("word_subtlex_word_id_idx").on(table.wordId),
    index("word_subtlex_rank_idx").on(table.rank),
  ],
);

export type WordSubtlex = typeof wordSubtlexTable.$inferSelect;
